export default (data, resolve, self) => {
  self.appearHero(resolve);
  self.DOM.$document.trigger('barba-page-enter');
}
